import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles((theme) =>
  createStyles({
    grid: {
      width: '100%',
    },
  }),
);
